var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 34.5,
    stroke: "#000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M44.59 46.5H27.41c-1.056 0-1.91-.895-1.91-2v-12c0-1.105.854-2 1.91-2h17.18c1.056 0 1.91.895 1.91 2v12c0 1.105-.854 2-1.91 2z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.071,
    height: 18.964,
    x: 30.464,
    y: 22.521,
    stroke: "#000",
    strokeWidth: 2,
    rx: 5.536
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3MiA3MiI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxjaXJjbGUgY3g9IjM2IiBjeT0iMzYiIHI9IjM0LjUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIzIi8+CiAgICAgICAgPHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNNDQuNTkgNDYuNUgyNy40MWMtMS4wNTYgMC0xLjkxLS44OTUtMS45MS0ydi0xMmMwLTEuMTA1Ljg1NC0yIDEuOTEtMmgxNy4xOGMxLjA1NiAwIDEuOTEuODk1IDEuOTEgMnYxMmMwIDEuMTA1LS44NTQgMi0xLjkxIDJ6Ii8+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjExLjA3MSIgaGVpZ2h0PSIxOC45NjQiIHg9IjMwLjQ2NCIgeT0iMjIuNTIxIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgcng9IjUuNTM2Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgLock as ReactComponent };